function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "dollar-sign@svg");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Regular/dollar",
  transform: "translate(-3.000000, 0.000000)",
  stroke: "#80A1FE",
  strokeWidth: 1.7
}, /*#__PURE__*/React.createElement("g", {
  id: "dollar-sign",
  transform: "translate(4.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.75,0 L3.75,13.75",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.875,2.5 L2.1875,2.5 C0.97937711,2.5 -8.8817842e-16,3.47937711 -8.8817842e-16,4.6875 C-8.8817842e-16,5.89562289 0.97937711,6.875 2.1875,6.875 L5.3125,6.875 C6.52062287,6.87500003 7.49999995,7.85437713 7.49999995,9.0625 C7.49999995,10.2706229 6.52062287,11.25 5.3125,11.25 L-8.8817842e-16,11.25",
  id: "Shape"
}))));

var SvgUsd = function SvgUsd(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "16px",
    viewBox: "0 0 10 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usd.380ba0d2.svg";
export { ForwardRef as ReactComponent };